module.exports = __webpack_public_path__ + "img/LogoZecon.5026f202.png";